module.exports = __webpack_public_path__ + "static/media/SR302-W1-P6C Copy.db9ffe69.png";